import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { requestAcadReinforceExists } from "services/acadReinforce/aboutAcadReinforce";
import { acadReinforcementSessionStorage } from "services/storage/acadReinforcement";

const CheckAcadReinforceExistence = ({
    loadingRequest,
    children,
    defaultPath
}) => {
    const [acadReinforceExists, setAcadReinforceExists] = useState(null);
    useEffect(() => {
        checkAcadReinforceExistence();
    }, []);
    const checkAcadReinforceExistence = async () => {
        const acadReinforceId = acadReinforcementSessionStorage.acadReinforceId.get();
        loadingRequest.show();
        const exists = await requestAcadReinforceExists(acadReinforceId);
        loadingRequest.hide();
        setAcadReinforceExists(exists);
    }
    if (acadReinforceExists === null) 
        return null;
    if (acadReinforceExists)
        return children;
    return (
        <Navigate 
            to={defaultPath}
            replace/>
    );
}

export default CheckAcadReinforceExistence;